import React, { useContext } from 'react'
// import SampleMessages from './steps/SampleMessages.tsx'
// import Policies from './steps/Policies.tsx'
import Usage from '../steps/Usage'
import PropTypes from 'prop-types'
import { useParams } from 'react-router-dom'
import { makeStyles } from '@material-ui/core'
import Contact from '../steps/Contact'
import SampleMessages from '../steps/SampleMessages'
import PreviewContainer from '../../shared/PreviewContainer'
import { EnrollmentType } from '../../../interface/EnrollmentType'
import { CampaignContext } from '../../../contexts/CampaignContext'

const jss = () => {
    return {
        mb40: {
            marginBottom: 40
        }
    }
}

const useStyles = makeStyles(jss)

interface PropsInterface {
    onGoBack(): unknown
    onClickEdit(id: number): unknown
    onClickSubmitPaymentFailed(id: number): unknown
}

/**
 * @param {object} props
 */
const Preview = ({
    onGoBack,
    onClickEdit,
    onClickSubmitPaymentFailed
}: PropsInterface) => {
    const styles = useStyles()

    const { campaigns } = useContext(CampaignContext)

    let { id } = useParams()
    id = Number.parseInt(id)

    const item = campaigns.find((x) => x.csp_campaign_id === id)

    if (!item) {
        return 'Not found'
    }

    return <PreviewContainer
        item={item}
        titleRight={`Campaign ID: ${item.csp_campaign_id}`}
        enrollmentType={EnrollmentType.Campaign}
        onGoBack={onGoBack}
    >
        <div className={styles.mb40} data-testid='campaign-preview'>
            <Usage
                editing={item}
                passData={{}}
                mode='preview'
                onClickEdit={() => onClickEdit(id)}
                onClickSubmitPaymentFailed={() => onClickSubmitPaymentFailed(id)}
            />
        </div>
        <div className={styles.mb40}>
            <SampleMessages
                editing={item}
                passData={{}}
                mode='preview'
            />
        </div>
        <div className={styles.mb40}>
            <Contact
                editing={item}
                passData={{}}
                mode='preview'
            />
        </div>
    </PreviewContainer>
}

Preview.propTypes = {
    passData: PropTypes.object,
    update: PropTypes.func,
    saveId: PropTypes.number,
    editing: PropTypes.object,
    preview: PropTypes.bool
}

export default Preview
